import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { AppHelper } from "../appHelper.js";
import { Helper } from "../core/util/helper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DayOfWeek } from "./repetitionInfo.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class CreateMultipleAssignments extends React.Component<CreateMultipleAssignmentsProps, any> {
    addressSearchEnabled: boolean;
    addressSearchVisible: boolean;
    projectSearchVisible: boolean;
    containerSearchVisible: boolean;
    flagDisabled: boolean;
    private common = new AppHelper();

    hasDispatchLicence: boolean;
    hasMobileLicence: boolean;

    constructor(props: CreateMultipleAssignmentsProps) {
        super(props);
        this.flagDisabled = !Helper.isNullOrEmpty(props.entity.FlagId);
        this.hasDispatchLicence = props.hasDispatchLicence;
        this.hasMobileLicence = props.hasMobileLicence;
        this.setSearchsVisibilties(props.entity.Code);
        this.common.init(this);
    }

    private setSearchsVisibilties = (key: number) => {
        const code = this.props.dataSources.codes.find(f => f.Key == key);
        this.projectSearchVisible = Helper.hasValue(code) && (code.Type == CodeType.ProjectRelated || code.Type == CodeType.Maintenance);
        this.addressSearchEnabled = Helper.hasValue(code) && code.Type == CodeType.AddressRelated;
        this.addressSearchVisible = this.addressSearchEnabled || this.projectSearchVisible;
        this.containerSearchVisible = Helper.hasValue(code) && (code.Type == CodeType.AddressRelated || code.Type == CodeType.Maintenance || code.Type == CodeType.ProjectRelated);
    }

    private onCodeChange = (code: Code) => {
        let type: CodeType = null;
        if (Helper.hasValue(code)) {
            type = code.Type;
            this.setSearchsVisibilties(code.Key);
        }
        let prevCode = this.props.dataSources.codes.find(f => f.Key == this.props.entity.Code);
        switch (type) {
            case CodeType.AddressRelated:
                this.handleFieldChange({ model: "entity.ProjNr" }, "");
                break;
            case CodeType.ProjectRelated:
            case CodeType.Maintenance:
                if (Helper.hasValue(prevCode) && prevCode.Type == CodeType.AddressRelated) {
                    this.handleFieldChange({ model: "entity.AdrNr" }, "");
                }
                break;
            default:
                this.handleFieldChange({ model: "entity.AdrNr" }, "");
                this.handleFieldChange({ model: "entity.ProjNr" }, "");
                break;
        }
    }

    private changeWeekendSchema = (key: number) => {
        const schema = this.props.context.weekendSchemas.find(schema => schema.Key == key);
        if (Helper.hasValue(schema)) {
            this.props.dataSources.weekEndWork = schema.WeekendWork;
            this.setState({}, () => {
                const item = this.props.dataSources.weekEndWork.find(ww => ww.Key == this.props.entity.WeekEndWork);
                if (!Helper.hasValue(item)) {
                    this.handleFieldChange({ model: "entity.WeekEndWork" }, 0);
                }
            });
        }
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Code":
                this.onCodeChange(dataItem);
                break;
            case "entity.RepetitionInfo":
                if (Helper.hasValue(value)) {
                    if (value.Repetition == Repetition.Workday) {
                        this.changeWeekendSchema(value.WeekendSchemaId);
                    } else if (Helper.hasValue(this.props.entity.RepetitionInfo) && this.props.entity.RepetitionInfo.Repetition == Repetition.Workday) {
                        this.changeWeekendSchema(null);
                    }
                }
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, this.afterHandleFieldChange);
    }

    private afterHandleFieldChange = () => {
        this.common.setEntityDirtyState(false);
    }

    private handleIsSearchFieldFullObjectModel = (field: { model: string }, object: any) => {
        switch (field.model) {
            case "entity.ProjNr":
                this.handleFieldChange({ model: "entity.ProjNr" }, object["projnr"]);
                this.handleFieldChange({ model: "entity.AdrNr" }, object["adrnr"]);
                break;
        }
    }

    private validateRepetition = () => {
        const info = this.props.entity.RepetitionInfo;
        if (Helper.hasValue(info.RepetitionUntil) || this.props.entity.RepetitionInfo.Repetition === Repetition.None) {
            if (info.Repetition === Repetition.Custom) {
                const con1 = Helper.hasValue(info.CustomRepetitionInfo.Start)
                    && Helper.hasValue(info.CustomRepetitionInfo.StartTime) && info.CustomRepetitionInfo.StartTime >= 0
                    && Helper.hasValue(info.CustomRepetitionInfo.AssignmentDuration) && info.CustomRepetitionInfo.AssignmentDuration > 0
                    && Helper.hasValue(info.CustomRepetitionInfo.RepeatAll) && info.CustomRepetitionInfo.RepeatAll > 0;
                if (!con1) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.CheckTimings"));
                }

                let con2 = false;
                switch (info.CustomRepetitionInfo.Repetition) {
                    case Repetition.Daily:
                        con2 = true;
                        break;
                    case Repetition.Weekly:
                        con2 = Helper.hasValue(info.CustomRepetitionInfo.DaysOfWeek) && info.CustomRepetitionInfo.DaysOfWeek.length > 0;
                        if (!con2) {
                            NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.CheckTimings"));
                        }
                        break;
                    case Repetition.Monthly:
                        const cm1 = Helper.hasValue(info.CustomRepetitionInfo.SpecificDay) && info.CustomRepetitionInfo.SpecificDay > 0 && info.CustomRepetitionInfo.SpecificDay < 32;
                        const cm2 = Helper.hasValue(info.CustomRepetitionInfo.Position) && Helper.hasValue(info.CustomRepetitionInfo.DayOfWeek);
                        con2 = cm1 || cm2;
                        if (!con2)
                            NotificationHelper.showWarningMessage("***Your details are invalid***");
                        break;
                }
                return con1 && con2;

            } else {
                const result = Helper.hasValue(info.StandardRepetitionInfo.AssignmentStart) && Helper.hasValue(info.StandardRepetitionInfo.AssignmentEnd)
                    && (Helper.dates.toDate(info.StandardRepetitionInfo.AssignmentStart) < Helper.dates.toDate(info.StandardRepetitionInfo.AssignmentEnd))
                    && (this.props.entity.RepetitionInfo.Repetition === Repetition.None || (Helper.dates.toDate(info.StandardRepetitionInfo.AssignmentEnd) <= Helper.dates.toDate(info.RepetitionUntil)));
                if (!result)
                    NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.CheckTimings"));
                return result;
            }
        } else {
            NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.Until"));
            return false;
        }
    }

    private validateRessourcesAndContainers = () => {
        const code = this.props.dataSources.codes.find(f => f.Key == this.props.entity.Code);
        const hasAtLeastOneResource = (Helper.hasValue(this.props.entity.Ressources) && this.props.entity.Ressources.length > 0);
        const hasAtLeastOneContainer = (Helper.hasValue(this.props.entity.Containers) && this.props.entity.Containers.filter(f => f.Amount > 0).length > 0);
        let result = hasAtLeastOneResource;
        if ((code.Type == CodeType.Absence) || (code.Type == CodeType.Vacation)) {
            result = hasAtLeastOneResource;
            if (!result)
                NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.OneResource"));
        } else {
            result ||= hasAtLeastOneContainer;
            if (!result)
                NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.MultipleCreation.Validation.OneResourceOrContainer"));
        }
        return result;
    }

    private validate = async () => {
        let result = (this.common.validate() as boolean) && this.validateRepetition() && this.validateRessourcesAndContainers();
        if (result) {
            const code = this.props.dataSources.codes.find(f => f.Key == this.props.entity.Code);
            result = (!Config.user.splitUpAndCutAssignment) || (code.Type !== CodeType.Vacation && code.Type !== CodeType.Absence) || await DialogHelper.confirm(Helper.getTranslation("Einsatz.MultipleCreation.Validation.Split"))
        }
        return result;
    }

    create = async () => {
        if (await this.validate()) {
            const creationInfo: AssignmentCreationInfo = JSON.parse(JSON.stringify(this.props.entity))
            creationInfo.Ressources = creationInfo.Ressources.map((item) => { return item.Value });
            const result = await HTTPService.post<JsonResultClass>("CreateMultipleAssignments/Create", {
                info: creationInfo
            });
            if (result.Code == 0) {
                
                NotificationHelper.showSuccessMessage(result.Message)
                await this.openScheduler(result.AdditionalData.MinDate);
            } else {
                NotificationHelper.showErrorMessage(result.Message)
            }
        }
    }

    private openScheduler = async (minDate) => {
        const isOk = await DialogHelper.choose(Helper.getTranslation("Einsatz.MultipleCreation.OpenScheduler"), [{ label: Helper.getTranslation("Server.No"), value: false }, { label: Helper.getTranslation("Server.Yes"), value: true, primary: true }])
        if (isOk) {
            location.href = Config.baseUrl + `ResourcePlanningScheduler/Index?start=${minDate}`
        }
    }

    componentDidMount() {
        this.setState({})
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} titleProps={""} />;
    }
}

export interface CreateMultipleAssignmentsProps extends AppBaseProps {
    entity: AssignmentCreationInfo;
    context: CreateMultipleAssignmentsContext;
    dataSources: CreateMultipleAssignmentsDataSources;
    hasDispatchLicence: boolean;
    hasMobileLicence: boolean;
}

export interface AssignmentCreationInfo extends Entity {
    Code: number;
    ProjNr: string;
    AdrNr: string;

    GroupId: number;
    FlagId: string;

    Title: string;
    Description: string;

    FixStart: boolean;
    FixEnd: boolean;
    WeekEndWork: number;

    RepetitionInfo: RepetitionInfo;

    Ressources: any[]; //Böser Hack
    Containers: ContainerInfo[];
}

export interface ContainerInfo {
    GroupId: number;
    Amount: number;
}

export interface RepetitionInfo {
    Repetition: Repetition;
    RepetitionUntil?: Date;
    WeekendSchemaId?: number;

    StandardRepetitionInfo: StandardRepetitionInfo;
    CustomRepetitionInfo: CustomRepetitionInfo;
}

export interface StandardRepetitionInfo {
    AssignmentStart: Date
    AssignmentEnd: Date
}

export interface CustomRepetitionInfo {
    Start: Date;
    AssignmentDuration: number;
    StartTime: number;

    RepeatAll: number;
    Repetition: Repetition;
    //Woche
    DaysOfWeek: DayOfWeek[];
    //Monat 1
    SpecificDay: number;
    //Monat 2
    DayOfWeek: DayOfWeek;
    Position: Position;
}

export enum Repetition {
    None = 0,
    Workday = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
    Annual = 5,
    Custom = 6
}

export enum Position {
    Last = -1,
    First = 0,
    Second = 1,
    Third = 2,
    Fourth = 3
}

export interface CreateMultipleAssignmentsContext extends Context {
    translations: StringKeyDictionary<string>;
    weekendSchemas: any[];
    start: Date;
    end: Date;
    duration: number;
}

export interface CreateMultipleAssignmentsDataSources {
    codes: Code[];
    weekEndWork: KeyValuePair<number, string>[];
    containers: KeyValuePair<number, string>[];
    repetitions: KeyValuePair<Repetition, string>[];
}

export interface Code {
    Key: number;
    Text: string;
    Type: CodeType;
    TypeText: string;
}

export enum CodeType {
    Vacation = 1,
    Absence = 2,
    AddressRelated = 4,
    ProjectRelated = 5,
    Maintenance = 6,
    InternalTimes = 7
}